import { render } from "./agreement2.vue?vue&type=template&id=06ac7094&scoped=true"
import script from "./agreement2.vue?vue&type=script&lang=js"
export * from "./agreement2.vue?vue&type=script&lang=js"

import "./agreement2.vue?vue&type=style&index=0&id=06ac7094&lang=less&scoped=true"

import exportComponent from "E:\\develop\\company\\gw\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06ac7094"]])

export default __exports__